import React from 'react';
import Slider from 'react-animated-slider';
 import 'react-animated-slider/build/horizontal.css';
import content from './content';
import './custom.css' 


function Custom() {
	let settings  = {
		 
		touchDisabled: true,
		autoplay:3000,
		  
	}
	return (
		
		<div>
			  
			<Slider  {...settings}>
				{content.map((item, index) => (
					<div key={index}
					
						className='sliderContent'
						style={{ background: `url('${item.image}') no-repeat center center` }}
					>
						<div className="inner">
							<h1>{item.title}</h1>
							<p>{item.description}</p>
							 
						</div>
						<section>
							<img src={item.userProfile} alt={item.user} />
							 
						</section>
					</div>
				))}
			</Slider>
		</div>
	);
}

export default Custom;